import { render, staticRenderFns } from "./VariableSelectChangeEvent.vue?vue&type=template&id=c3470bd0&"
import script from "./VariableSelectChangeEvent.vue?vue&type=script&lang=ts&"
export * from "./VariableSelectChangeEvent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports